import { AlertRuleRow } from '../types';

export type AlertRuleCategory = 'portainer' | 'security' | 'environment';
export type AlertRuleCategoryFilter = AlertRuleCategory | 'all';

export const alertRuleCategoryOrder: AlertRuleCategory[] = [
  'portainer',
  'security',
  'environment',
];

export function resolveAlertRuleCategory(
  rule: Pick<AlertRuleRow, 'category' | 'labels' | 'supportedEnvironmentTypes'>
): AlertRuleCategory {
  const categoryFromField = normalizeAlertRuleCategory(rule.category);
  if (categoryFromField) {
    return categoryFromField;
  }

  const categoryFromLabel = normalizeAlertRuleCategory(rule.labels?.category);
  if (categoryFromLabel) {
    return categoryFromLabel;
  }

  if (rule.supportedEnvironmentTypes) {
    return 'environment';
  }

  return 'portainer';
}

export function getAlertRuleCategoryLabel(category: AlertRuleCategory): string {
  switch (category) {
    case 'portainer':
      return 'Portainer';
    case 'security':
      return 'Security';
    case 'environment':
      return 'Environment';
  }
}

function normalizeAlertRuleCategory(
  value?: string
): AlertRuleCategory | undefined {
  if (!value) {
    return undefined;
  }

  switch (value.toLowerCase().trim()) {
    case 'portainer':
    case 'backup':
      return 'portainer';
    case 'security':
      return 'security';
    case 'environment':
      return 'environment';
    default:
      return undefined;
  }
}
